import { render, staticRenderFns } from "./SelfRegisteredVendorEdit.vue?vue&type=template&id=8d6dd7da&scoped=true&"
import script from "./SelfRegisteredVendorEdit.vue?vue&type=script&lang=js&"
export * from "./SelfRegisteredVendorEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfRegisteredVendorEdit.vue?vue&type=style&index=0&id=8d6dd7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6dd7da",
  null
  
)

export default component.exports